/*
 * @Author: chengyu
 * @Date: 2022-09-22 14:05:48
 * @Description: 通用请求方法
 */
var _a;
import { getConfig } from '../../config';
import { ContextEnvEnum } from '../../enums';
import ap from './ap';
import base from './base';
import jsonp from './jsonp';
import taro from './taro';
import wx from './wx';
var RequestMap = (_a = {},
    _a[ContextEnvEnum.BROWSER] = base,
    _a[ContextEnvEnum.TARO] = taro,
    _a[ContextEnvEnum.ALIPAY] = ap,
    _a[ContextEnvEnum.WECHAT] = wx,
    _a[ContextEnvEnum.NODE] = base,
    _a);
/**
 * 注册各环境下请求方法
 */
function registerRequest() {
    var request;
    return function () {
        var config = getConfig();
        if (request)
            return request;
        request = RequestMap[config.contextEnv]();
        request.config.headers = {
            'Content-Type': 'application/json',
        };
        request.config.timeout = 6 * 1000;
        return request;
    };
}
function registerJsonp() {
    var request;
    return function () {
        if (request)
            return request;
        request = jsonp();
        return request;
    };
}
export var getRequest = registerRequest();
export var getJsonp = registerJsonp();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29yZS9yZXF1ZXN0L2h0dHAvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRzs7QUFJSCxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBQ3pDLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFFN0MsT0FBTyxFQUFFLE1BQU0sTUFBTSxDQUFDO0FBQ3RCLE9BQU8sSUFBSSxNQUFNLFFBQVEsQ0FBQztBQUMxQixPQUFPLEtBQUssTUFBTSxTQUFTLENBQUM7QUFDNUIsT0FBTyxJQUFJLE1BQU0sUUFBUSxDQUFDO0FBQzFCLE9BQU8sRUFBRSxNQUFNLE1BQU0sQ0FBQztBQUV0QixJQUFNLFVBQVU7SUFDZCxHQUFDLGNBQWMsQ0FBQyxPQUFPLElBQUcsSUFBSTtJQUM5QixHQUFDLGNBQWMsQ0FBQyxJQUFJLElBQUcsSUFBSTtJQUMzQixHQUFDLGNBQWMsQ0FBQyxNQUFNLElBQUcsRUFBRTtJQUMzQixHQUFDLGNBQWMsQ0FBQyxNQUFNLElBQUcsRUFBRTtJQUMzQixHQUFDLGNBQWMsQ0FBQyxJQUFJLElBQUcsSUFBSTtPQUM1QixDQUFDO0FBRUY7O0dBRUc7QUFDSCxTQUFTLGVBQWU7SUFDdEIsSUFBSSxPQUFZLENBQUM7SUFFakIsT0FBTztRQUNMLElBQU0sTUFBTSxHQUFHLFNBQVMsRUFBRSxDQUFDO1FBRTNCLElBQUksT0FBTztZQUFFLE9BQU8sT0FBTyxDQUFDO1FBQzVCLE9BQU8sR0FBRyxVQUFVLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxFQUFFLENBQUM7UUFDMUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxPQUFPLEdBQUc7WUFDdkIsY0FBYyxFQUFFLGtCQUFrQjtTQUNuQyxDQUFDO1FBQ0YsT0FBTyxDQUFDLE1BQU0sQ0FBQyxPQUFPLEdBQUcsQ0FBQyxHQUFHLElBQUksQ0FBQztRQUNsQyxPQUFPLE9BQU8sQ0FBQztJQUNqQixDQUFDLENBQUM7QUFDSixDQUFDO0FBRUQsU0FBUyxhQUFhO0lBQ3BCLElBQUksT0FBWSxDQUFDO0lBRWpCLE9BQU87UUFDTCxJQUFJLE9BQU87WUFBRSxPQUFPLE9BQU8sQ0FBQztRQUM1QixPQUFPLEdBQUcsS0FBSyxFQUFFLENBQUM7UUFDbEIsT0FBTyxPQUFPLENBQUM7SUFDakIsQ0FBQyxDQUFDO0FBQ0osQ0FBQztBQUVELE1BQU0sQ0FBQyxJQUFNLFVBQVUsR0FBRyxlQUFlLEVBQUUsQ0FBQztBQUM1QyxNQUFNLENBQUMsSUFBTSxRQUFRLEdBQUcsYUFBYSxFQUFFLENBQUMifQ==